export const PerimetersOrgChartNodeType = {
  TAG: 't',
  PERIMETER: 'p',
} as const

export type PerimetersOrgChartNodeType = (typeof PerimetersOrgChartNodeType)[keyof typeof PerimetersOrgChartNodeType]

export const PerimetersOrgChartNodeAction = {
  IDENTITY_CARD: 'identity-card',
  ADD: 'add',
  SHOW: 'show',
  MOVE: 'move',
  EDIT: 'edit',
  DELETE: 'delete',
} as const

export type PerimetersOrgChartNodeAction =
  (typeof PerimetersOrgChartNodeAction)[keyof typeof PerimetersOrgChartNodeAction]

export interface PerimetersOrgChartNodeScore {
  score: number | string | null
  color?: string
}

export interface PerimetersOrgChartNodeConfidence {
  score: number
}

export interface PerimetersOrgChartNode {
  id: string
  db_id: number
  parentId: string | null
  has_parent?: boolean
  type: PerimetersOrgChartNodeType
  identifier: string
  name: string | null
  weight?: number | null
  color?: string | null
  perimeter_type?: string | null
  mandatory_input?: boolean
  edit_right: boolean
  delete_right: boolean
  trusted_perf?: PerimetersOrgChartNodeScore | null
  trusted_confidence?: PerimetersOrgChartNodeConfidence | null
  _expanded?: boolean
  // A virtual node is a frontend only node like "My perimeters" to regroup the user multiple perimeter accesses
  isVirtual?: boolean
  isPerimeterAccessRoot?: boolean
}

export interface PerimetersOrgChartMoveTarget extends PerimetersOrgChartNode {
  depth: number
}

export interface PerimetersOrgChartHierarchyNode {
  data: PerimetersOrgChartNode
  children?: PerimetersOrgChartHierarchyNode[] | null
  _children?: PerimetersOrgChartHierarchyNode[] | null
}

export interface PerimetersOrgChartNodeEvent {
  data: PerimetersOrgChartNode
}

export interface PerimetersOrgChartActionContext {
  node: PerimetersOrgChartNode
  canAddNode: boolean
  isGlobalPilot: boolean
}
